<template>
  <div>
    <div class="content-body">
      <section id="basic-datatable">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h5 class="card-title">{{ $t("Manage Templates") }}</h5>
                  <div class="heading-elements">
                    <ul class="list-inline mb-0">
                      <li class="spacing">
                        <button
                          class="btn btn-primary"
                          @click="createContractModal()"
                        >
                          {{ $t("Create Template") }}
                        </button>
                      </li>
                      <li class="spacing">
                        <div class="has-icon-left">
                          <select
                            class="form-control"
                            v-model="countryFilter"
                            @change="filterByCountry(countryFilter)"
                          >
                            <option selected>
                              {{ $t("All Countries...") }}
                            </option>
                            <option
                              v-for="(country, index) in usersCountries"
                              :value="country"
                              :key="index"
                            >
                              {{ countryName(country) }}
                            </option>
                          </select>
                          <div class="form-control-position">
                            <em class="bx bx-map font-medium-1"></em>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="has-icon-left">
                          <select
                            class="form-control"
                            v-model="statusFilter"
                            @change="filterByStatus(statusFilter)"
                          >
                            <option selected>{{ $t("All Status...") }}</option>
                            <option value="draft">{{ $t("Draft") }}</option>
                            <option value="published">
                              {{ $t("Published") }}
                            </option>
                            <option value="archived">
                              {{ $t("Archived") }}
                            </option>
                          </select>
                          <div class="form-control-position">
                            <em class="bx bx-filter font-medium-1"></em>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-body card-dashboard">
                  <div class="text-center">
                    <div
                      class="spinner-border text-primary"
                      role="status"
                      v-if="loadingData"
                      style="opacity: 0.6"
                    >
                      <span class="sr-only">{{ $t("Loading...") }}</span>
                    </div>
                  </div>
                  <div
                    class="text-center mt-1"
                    v-if="!templates.length && !loadingData"
                  >
                    <p>{{ $t("No Templates Found...") }}</p>
                  </div>
                  <div class="table-responsive" v-if="templates.length">
                    <ContractTemplateList
                      :countryName="countryName"
                      :templates="templates"
                      :editTemplateModal="editTemplateModal"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Create Template Modal -->
    <div
      class="modal fade text-left"
      id="create-contract-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true"
    >
      <CreateTemplate
        type="create"
        :languages="languages"
        :getTemplatesDocusign="getTemplatesDocusign"
        :countries="countries"
        ref="createTemplateRef"
      />
    </div>

    <!-- Edit Template Modal -->
    <div
      class="modal fade text-left edit-contract-modal"
      id="edit-contract-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-full"
        role="document"
      >
        <EditTemplate
          :languages="languages"
          :countries="countries"
          :getTemplatesDocusign="getTemplatesDocusign"
          ref="editTemplateRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import Alert from "@/components/Alerts";
import TButton from "@/components/Contracts/templates/TButton.vue";
import CreateTemplate from "@/components/Contracts/templates/CreateTemplate.vue";
import EditTemplate from "@/components/Contracts/templates/EditTemplate.vue";
import ContractTemplateList from "@/components/Contracts/templates/ContractTemplateList.vue";

/** Page CSS */
import "@/app-assets/vendors/css/tables/datatable/datatables.min.css";
import "@/app-assets/vendors/css/tables/datatable/extensions/dataTables.checkboxes.css";
import "@/app-assets/vendors/css/tables/datatable/responsive.bootstrap.min.css";
import "@/app-assets/css/pages/app-invoice.css";

export default {
  data() {
    return {
      templates: [],
      languages: {
        primaryLanguage: {
          label: "English",
          lang: "en",
        },
        secondaryLanguages: [
          {
            label: "Polish",
            lang: "pl",
          },
          {
            label: "Arabic",
            lang: "ar",
          },
          {
            label: "French",
            lang: "fr",
          },
        ],
      },
      countries: [],
      target: [],
      usersCountries: [],
      loadingData: true,
      countryFilter: "All Countries...",
      statusFilter: "All Status...",
      error: false,
    };
  },

  components: {
    Alert,
    TButton,
    CreateTemplate,
    EditTemplate,
    ContractTemplateList
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    },
  },

  methods: {
    createContractModal() {
      $("#create-contract-modal").modal();
      this.$refs.createTemplateRef.onOpen();
    },
    getTemplatesDocusign() {
      let self = this;
      self.loadingData = true;
      self.templates = [];
      this.$apiCall.get("/v1/contracts/templates").then((response) => {
        response.data.data.forEach(function (element) {
          if (
            !self.usersCountries.includes(element.country) &&
            element.country
          ) {
            self.usersCountries.push(element.country);
          }
        });
        self.loadingData = false;
        self.templates = response.data.data;
        self.initDataTable();
      });
    },

    filterByCountry(country) {
      let self = this;
      if (country != "All Countries...") {
        self.loadingData = true;
        self.templates = [];
        self.$apiCall
          .get(`/v1/contracts/templates?country=${country}`)
          .then((response) => {
            self.loadingData = false;
            self.templates = response.data.data;
            self.initDataTable();
          });
      } else {
        self.templates = [];
        self.usersCountries = [];
        self.getTemplatesDocusign();
      }
    },

    filterByStatus(status) {
      let self = this;
      if (status != "All Status...") {
        self.loadingData = true;
        self.templates = [];
        self.$apiCall
          .get(`/v1/contracts/templates?status=${status.toLowerCase()}`)
          .then((response) => {
            self.loadingData = false;
            self.templates = response.data.data;
            self.initDataTable();
          });
      } else {
        self.templates = [];
        self.usersCountries = [];
        self.getTemplatesDocusign();
      }
    },

    editTemplateModal(uid) {
      $("#edit-contract-modal").modal();
      this.$refs.editTemplateRef.onOpen(uid);
    },

    getActiveCountries() {
      const countries = localStorage.getItem("activeCountries");
      this.countries =
        countries && countries != "" ? countries.split(",") : ["LB", "JO"];
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    initDataTable() {
      let self = this;
      setTimeout(function () {
        $(".zero-configuration").DataTable({
          bLengthChange: false,
          bFilter: false,
          order: [],
        });
      }, 100);
    },

    loadFormPlugin() {
      $(
        ".file-repeater, .contact-repeater, .repeater-default, .repeater-default-edit, .repeater-default-new"
      ).repeater({
        show: function () {
          $(this).slideDown();
        },
        hide: function (deleteElement) {
          $(this).slideUp(deleteElement);
        },
      });
    },
  },

  mounted() {
    this.getTemplatesDocusign();
    this.getActiveCountries();
    this.loadFormPlugin();

    if (navigator.appVersion.indexOf("Chrome/") != -1) {
      $("li > .btn.btn-primary").addClass("mt-chrome");
    } else {
      $("li > .btn.btn-primary").addClass("mt-firefox");
    }
  },
};
</script>

<style scoped>
.validation-error {
  border: solid 1px red !important;
}
.spacing {
  margin-right: 1em;
}
</style>